__turbopack_context__.v({
  "carouselContainer": "WinnerCarousel-module__vPpEAG__carouselContainer",
  "carouselContent": "WinnerCarousel-module__vPpEAG__carouselContent",
  "carouselImageWrapper": "WinnerCarousel-module__vPpEAG__carouselImageWrapper",
  "carouselOverlay": "WinnerCarousel-module__vPpEAG__carouselOverlay",
  "carouselSlide": "WinnerCarousel-module__vPpEAG__carouselSlide",
  "carouselTextContent": "WinnerCarousel-module__vPpEAG__carouselTextContent",
  "winnerCarousel": "WinnerCarousel-module__vPpEAG__winnerCarousel",
  "winnerPrize": "WinnerCarousel-module__vPpEAG__winnerPrize",
  "winnersGrid": "WinnerCarousel-module__vPpEAG__winnersGrid",
});
